import React from 'react';

import classes from './ChargingPointIcon.module.scss';
import MIcon from 'views/MIcon/MIcon';
import { MIconName } from 'views/MIcon/MIcon.model';
import { ConnectorStatus } from 'utils/enums/chargingType';

type Props = {
  icon: MIconName;
  status: ConnectorStatus;
  id: number;
  isChosen: boolean;
};

const ChargingPointIconView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {

  return (
    <div>
      <MIcon
        className={`${classes['icon']} ${
          props.isChosen
            ? classes['icon--choosen']
            : props.status === ConnectorStatus.Free
              ? classes['icon--free']
              : props.status === ConnectorStatus.Error
                ? classes['icon--broken']
                : props.status === ConnectorStatus.Unknown
                  ? classes['icon--unknown']
                  : props.status === ConnectorStatus.Busy
                    ? classes['icon--busy']
                    : null
        }`}
        name={props.icon}
        size="l"
      ></MIcon>
    </div>
  );
};

ChargingPointIconView.displayName = 'ChargingPointIconView';
ChargingPointIconView.defaultProps = {};

export default ChargingPointIconView;
